"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var OrgEntitlementsTable = /*#__PURE__*/function () {
  OrgEntitlementsTable.$inject = ["$element", "$scope"];
  /* @ngInject */
  function OrgEntitlementsTable($element, $scope) {
    _classCallCheck(this, OrgEntitlementsTable);
    this.$scope = $scope;
  }

  /**
   * Builds the column titles based on the row keys on changes on the rows
   *
   * @param {Object} changes
   */
  _createClass(OrgEntitlementsTable, [{
    key: "$onChanges",
    value: function $onChanges(changes) {
      if (changes.rows && changes.rows.currentValue) {
        this.columnTitles = changes.rows.currentValue.reduce(function (accumulator, row) {
          for (var _i = 0, _Object$keys = Object.keys(row); _i < _Object$keys.length; _i++) {
            var columnTitle = _Object$keys[_i];
            if (accumulator.indexOf(columnTitle) === -1 && columnTitle.indexOf('_') === -1) {
              accumulator.push(columnTitle);
            }
          }
          return accumulator;
        }, []);
      }
    }

    /**
     * Emits 'LOAD_PREVIOUS_TRANSACTION_PAGE' on previous page button click
     *
     */
  }, {
    key: "onPreviousPageButtonClick",
    value: function onPreviousPageButtonClick() {
      if (!this.hasPreviousPage) return;
      this.$scope.$emit('LOAD_PREVIOUS_TRANSACTION_PAGE', this.productName);
    }

    /**
     * Emits 'LOAD_NEXT_TRANSACTION_PAGE' on next page button click
     *
     */
  }, {
    key: "onNextPageButtonClick",
    value: function onNextPageButtonClick() {
      if (!this.hasNextPage) return;
      this.$scope.$emit('LOAD_NEXT_TRANSACTION_PAGE', this.productName);
    }
  }]);
  return OrgEntitlementsTable;
}();
module.exports = angular.module('backstage.components.orgs.view-org.entitlements-manager.org-entitlements-table', ['backstage.services']).component('bsOrgEntitlementsTable', {
  templateUrl: '/src/angular/components/orgs/view-org/org-entitlements-manager/org-entitlements-table/org-entitlements-table.html',
  bindings: {
    rows: '<',
    loading: '<',
    emptyText: '@',
    productName: '@',
    hasNextPage: '<',
    hasPreviousPage: '<',
    organization: '<'
  },
  controllerAs: 'vm',
  controller: OrgEntitlementsTable
}).name;